import { InvitationType } from '@/models/Invitations'
import { GokollabService } from '@/service/GokollabService'
import { InvitationsService } from '@/service/InvitationService'
import { isGokollab } from '@ghl/clientportal-core/init'
import { AxiosError } from 'axios'
import { reactive } from 'vue'
import { GroupState } from './groups'
import { UserState } from './users'
export class InvitationsState {
  state = reactive({
    invitationLink: '',
    inviteeDetails: new Map<string, string>(),
    showInvitationModal: false,
    forbiddenInvitation: false,
    gokollabInvitationLink: '',
  })
  constructor() {}
  async createInvitation(invitationsPayload) {
    try {
      const invitation = isGokollab()
        ? await this.handleGokollabInvitation(invitationsPayload)
        : await InvitationsService.create({
            ...invitationsPayload,
            locationId: GroupState.state.groupData.locationId,
            groupId: GroupState.state.groupData._id,
            invitationType:
              invitationsPayload?.invitationType || InvitationType.EMAIL,
            createdBy: UserState.state.currentUser?.contactId,
          })
      if (isGokollab()) {
        this.state.gokollabInvitationLink =
          invitation?.referralLink || GroupState.state.groupLink
      }
      this.state.invitationLink = isGokollab()
        ? this.state.gokollabInvitationLink
        : GroupState.state.groupLink + '?invite=' + invitation._id
    } catch (error) {
      const transformedError = error as AxiosError
      if (transformedError?.response?.status === 403) {
        this.state.forbiddenInvitation = true
      }
    }
  }

  async handleGokollabInvitation(invitationsPayload) {
    try {
      if (invitationsPayload.invitationType === InvitationType.LINK) {
        return await GokollabService.generateInvitationLink(
          GroupState.state.groupData.locationId,
          GroupState.state.groupData._id
        )
      } else {
        await GokollabService.generateLead(
          GroupState.state.groupData.locationId,
          {
            name: invitationsPayload.invitationDetails.fullName,
            email: invitationsPayload.invitationDetails.email,
            groupId: GroupState.state.groupData._id,
            affiliateUrl: this.state.gokollabInvitationLink,
          }
        )
        return {
          referralLink: this.state.gokollabInvitationLink,
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  resetErrors() {
    this.state.forbiddenInvitation = false
  }

  resetState(): void {
    this.state.invitationLink = ''
    this.state.gokollabInvitationLink = ''
  }

  async acceptInvitation(invitationId) {
    return InvitationsService.acceptInvitation(invitationId)
  }

  async cancelInvitation(invitationId) {
    return await InvitationsService.delete(invitationId)
  }

  async fetchInvitation(invitationId) {
    let invitee = this.state.inviteeDetails.get(invitationId)
    if (invitee) {
      return invitee
    }

    const invitations = await InvitationsService.findById(invitationId)
    this.state.inviteeDetails.set(
      invitationId,
      invitations._data[0].inviteeName
    )
    return invitations._data[0].inviteeName
  }
}
export const InvitationState = new InvitationsState()
